import React from "react";
import { Layout } from "antd";
import TableView from "./TableView";
const { Content } = Layout;

export default class NoPageFound extends React.Component {
  render() {
    return (
      <div>
        <h2>No Page Found!</h2>
      </div>
    );
  }
}
